import type { COUNTRY } from '@shared/core-types';

import type { ThirdPartyProvidersFeature } from '../types';
import { thirdPartyProviders as AT } from './AT';
import { thirdPartyProviders as CZ } from './CZ';
import { thirdPartyProviders as RO } from './RO';
import { thirdPartyProviders as SK } from './SK';

type BusinessCountry = Extract<COUNTRY, 'AT' | 'RO' | 'CZ' | 'SK'>;
export const thirdPartyProvidersFeatureMap: Record<BusinessCountry, ThirdPartyProvidersFeature> = {
    AT,
    CZ,
    RO,
    SK,
};
